import React from "react";
import BlogCardsRow from "../components/BlogCardsRow";
import HeroImageSection from "../components/HeroImageSection";
import solarservices from "../assets/solarservice.jpeg";
import { Helmet } from "react-helmet-async";
import wpPosts from "../data/wpPosts.json";
import { fallbackBlogs } from "../data/blogFallback";
import { SOCIAL_IMAGE } from "../lib/seo";

// Reads the posts baked into the bundle by `npm run fetch:posts`, so the page
// renders instantly and makes no network call. That matters because
// blog.savorka.in is on shared hosting that serialises requests and returns
// 503 under load -- fetching it at runtime made every visitor share that
// problem. Publishing is now a fetch + commit + deploy; see
// scripts/fetch-posts.mjs.
const blogs = wpPosts.length > 0 ? wpPosts : fallbackBlogs();

const BlogPage = () => {
  return (
    <div className="bg-white">
<Helmet>
  {/* Primary SEO */}
  <title>
    Solar Energy Blogs & Guides | Savorka Solar
  </title>

  <meta
    name="description"
    content="Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance, and the latest solar industry trends with Savorka Solar."
  />

  <meta
    name="keywords"
    content="solar panel installation, solar subsidy, pm surya ghar yojana, Solar Energy"
  />

  <meta name="robots" content="index, follow" />

  <link
    rel="canonical"
    href="https://www.savorka.in/blogs/"
  />

  {/* Open Graph */}
  <meta property="og:type" content="website" />
  <meta
    property="og:title"
    content="Solar Energy Blogs & Guides | Savorka Solar"
  />
  <meta
    property="og:description"
    content="Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance, and the latest solar industry trends."
  />
  <meta
    property="og:url"
    content="https://www.savorka.in/blogs/"
  />
  <meta
    property="og:image"
    content={SOCIAL_IMAGE}
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />
  <meta
    name="twitter:title"
    content="Solar Energy Blogs & Guides | Savorka Solar"
  />
  <meta
    name="twitter:description"
    content="Expert blogs on solar panel installation, solar subsidy, rooftop solar systems and renewable energy."
  />
  <meta
    name="twitter:image"
    content={SOCIAL_IMAGE}
  />

  {/* Blog Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@type": "Blog",
      "name": "Savorka Solar Blog",
      "url": "https://www.savorka.in/blogs/",
      "description":
        "Read expert blogs on solar panel installation, solar subsidy, PM Surya Ghar Yojana, rooftop solar systems, maintenance and renewable energy.",
      "publisher": {
        "@type": "Organization",
        "name": "Savorka Solar",
        "logo": {
          "@type": "ImageObject",
          "url": "https://www.savorka.in/logo.png"
        }
      },
      "inLanguage": "en-IN"
    })}
  </script>
</Helmet>
      <HeroImageSection
        title="OUR BLOGS"
        heroImage={solarservices}
        altText="Savorka Solar blog"
      />

      <section className="px-5 py-12">
        <BlogCardsRow blogs={blogs} />
      </section>

    </div>
  );
};

export default BlogPage;
